

export function isLocalStorageNameSupported() {
  let testKey = 'test';
  let storage = window.localStorage;
  try {
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    return false;
  }
}


export function readLocalStorage(key) {
  if (isLocalStorageNameSupported()) {
    return window.localStorage[key];
  } else {
    console.error("not support localStorage.");
    return null;
  }
}

export function saveToLocalStorage(key, content) {
  if (isLocalStorageNameSupported()) {
    window.localStorage[key] = content;
  } else {
    console.error("not support localStorage.");
  }
}




// WEBPACK FOOTER //
// ./src/utils/Utils.js